import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-documents-xml-icon',
  templateUrl: './documents-xml.component.html'
})
export class DocumentsXmlComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
